export const isAdmin = window?.shopify?.origin?.includes('admin.shopify.com');
